import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import { type Observable, of } from 'rxjs';

import { WithArtifactService } from '@app/assets/common/artifact.service';
import { WithAuditService } from '@app/assets/common/audit.service';
import { type TestCodeEvent, TestCodeService } from '@app/assets/common/test-code.service';
import type { RagDto } from '@app/assets/rag/rag.dto';
import { RAG_PATH } from '@app/shared/api/api-route.config';
import { WithExportableService } from '@app/shared/api/export.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithWorkflowableService } from '@app/shared/approval/workflow.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithCrudVersionService } from '@app/shared/change-log/version.service';
import { MODEL_INPUT_TYPE } from '@app/shared/common/shared.constant';
import { WithJobService } from '@app/shared/job-history/job.service';
import { WithLineageService } from '@app/shared/lineage/lineage.service';
import { ToastNotificationService } from '@app/shared/notification/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class RagService extends classes(
    WithCrudVersionService<RagDto>,
    WithLineageService,
    WithAuditService,
    WithArtifactService,
    WithWorkflowableService,
    WithLogService,
    WithExportableService,
    WithJobService,
) {
    protected endpoint = RAG_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);
    private readonly testCodeService = inject(TestCodeService);
    /**
     * RAG supports API, Custom as definition input type
     * @returns list of supported definition input types
     */
    getInputTypes() {
        return of({
            result: [
                {
                    name: MODEL_INPUT_TYPE.API_BASED,
                    text: 'API Based',
                },
                {
                    name: MODEL_INPUT_TYPE.PYTHON_FUNCTION,
                    text: 'Python Function',
                },
            ],
        });
    }

    runDebugCode(request: { id: number; code: string }): Observable<TestCodeEvent> {
        return this.testCodeService.run(`${this.endpoint}${request.id}/debug_code`, request.code);
    }
}
